export default class Renegociacao {
  constructor(consignacoesIds = [], consignacao = null) {
    this.consignacoesIds = consignacoesIds
    this.consignacao = consignacao
  }
}
